import { MDBIcon, MDBSpinner } from "mdb-react-ui-kit";
import { ParamData } from "./AdvancedSettings";
import { LoadingSpinner } from "../../LoadingSpinner";
import { useMemo } from "react";

export interface ASNavButtonProps {
    param: ParamData;
    active: boolean;
    onClick: () => void;
    icon: string;
}

export const ASNavButton = ({
    param,
    active,
    onClick,
    icon
}: ASNavButtonProps) => {
    const loading = useMemo(() => param.reading || param.writing, [param.reading, param.writing]);


    return (
        <div role="button"
            className={`d-flex align-items-center list-group-item${active?' active':''} user-select-none ps-2 py-2 pe-3`} style={{flexWrap: "nowrap", fontSize: 14}}
            onClick={onClick}
        >
            <MDBIcon icon={icon} fixed/>
            <span className="ms-1" style={{whiteSpace: 'nowrap', textOverflow: "clip", overflow: 'hidden', lineHeight: 1.1}}>{param.param.name}</span>
            <div className="flex-fill"></div>
            <MDBSpinner role="status" size="sm" className="" style={{opacity: loading ? 1 : 0}}/>
        </div>
    )
}